import React from 'react'
import { InjectHtml } from '@/components/ui'
import type { IConditionsProps } from '../interfaces'

const LandingConditionsDesktop: React.FC<IConditionsProps> = ({ conditions }) => {
  return (
    <div>
      {conditions?.map(({ caption, text }) => {
        return (
          <section className="landing-constructor-conditions-row" key={caption}>
            <h5 className="landing-constructor-conditions-row__caption">{caption}</h5>

            <InjectHtml html={text} className="landing-constructor-conditions-row__content" />
          </section>
        )
      })}
    </div>
  )
}

export default LandingConditionsDesktop
